import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const KidsPool = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="kids-pool"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.2069 14.6969H6.90942C7.24976 16.3664 8.72945 17.6266 10.498 17.6266H12.2069C13.0147 17.6266 13.6718 16.9695 13.6718 16.1617C13.6718 15.354 13.0147 14.6969 12.2069 14.6969Z" />
      <path d="M19.5262 12.1308C20.7491 11.1663 21.4844 9.68208 21.4844 8.10508C21.4844 6.65088 20.8632 5.25952 19.7801 4.28784C18.6979 3.31694 17.242 2.85083 15.7855 3.00928C13.397 3.26909 11.4919 5.19575 11.2559 7.59053C11.1621 8.54204 11.3263 9.47012 11.7248 10.3023H5.91592C4.78091 10.3023 3.673 9.90483 2.79634 9.18316C2.27969 8.75791 1.58315 8.671 0.978516 8.9564C0.375 9.24136 0 9.83325 0 10.5011V13.4762C0 18.1878 3.83325 22.0211 8.54492 22.0211H14.6806C16.909 22.0211 18.8947 20.8633 19.9923 18.9241C21.0899 16.9848 21.0604 14.6864 19.9135 12.776L19.5262 12.1308ZM12.207 19.0914H10.498C7.67104 19.0914 5.37109 16.7915 5.37109 13.9645C5.37109 13.56 5.69902 13.232 6.10352 13.232H12.207C13.8225 13.232 15.1367 14.5463 15.1367 16.1617C15.1367 17.7771 13.8225 19.0914 12.207 19.0914ZM17.5781 8.54453C17.1736 8.54453 16.8457 8.2166 16.8457 7.81211C16.8457 7.40762 17.1736 7.07969 17.5781 7.07969C17.9826 7.07969 18.3105 7.40762 18.3105 7.81211C18.3105 8.2166 17.9826 8.54453 17.5781 8.54453Z" />
      <path d="M22.7551 9.67506C24.0534 9.27691 25.0001 8.06715 25.0001 6.6402C25.0001 6.38634 24.8687 6.1506 24.6528 6.01715C24.4369 5.88371 24.1672 5.8716 23.9402 5.98507C23.5526 6.17887 23.1419 6.31364 22.7217 6.39C22.8714 6.94445 22.9494 7.52076 22.9494 8.10504C22.9494 8.63683 22.8826 9.16412 22.7551 9.67506Z" />
    </svg>
  );
};
/* eslint-enable max-len */

KidsPool.defaultProps = {
  className: null,
};

KidsPool.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default KidsPool;
